<template>
  <header class="header">
    <div class="header-top">
      <div class="container">
        <ul class="contact-list">
          <li class="contact-item">
            <ion-icon name="mail-outline" class="mb hydrated"></ion-icon>

            <a href="mailto:dental@example.com" class="contact-link"
              >dental@example.com</a
            >
          </li>

          <li class="contact-item">
            <ion-icon name="call-outline" class="mb"></ion-icon>

            <a href="tel:+917052101786" class="contact-link">+1-7052-101-786</a>
          </li>
        </ul>

        <ul class="social-list">
          <li>
            <a href="#" class="social-link">
              <ion-icon name="logo-facebook"></ion-icon>
            </a>
          </li>

          <li>
            <a href="#" class="social-link">
              <ion-icon name="logo-instagram"></ion-icon>
            </a>
          </li>

          <li>
            <a href="#" class="social-link">
              <ion-icon name="logo-twitter"></ion-icon>
            </a>
          </li>

          <li>
            <a href="#" class="social-link">
              <ion-icon name="logo-youtube"></ion-icon>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="header-bottom" ref="header">
      <div class="container">
        <router-link to="/dental/" class="logo">Dental.</router-link>

        <nav class="navbar container" ref="navbar">
          <ul class="navbar-list">
            <li>
              <router-link to="/dental/" class="navbar-link" @click="closeNav"
                >Home</router-link
              >
            </li>

            <li>
              <router-link
                to="/dental/Service"
                class="navbar-link"
                @click="closeNav"
              >
                Services</router-link
              >
            </li>

            <li>
              <router-link
                to="/dental/About"
                class="navbar-link"
                @click="closeNav"
              >
                About Us</router-link
              >
            </li>

            <li>
              <router-link
                to="/dental/Team"
                class="navbar-link"
                @click="closeNav"
              >
                Team</router-link
              >
            </li>

            <li>
              <router-link
                to="/dental/Blog"
                class="navbar-link"
                @click="closeNav"
              >
                Blog</router-link
              >
            </li>
          </ul>
        </nav>

        <a href="#" class="btn">Book appointment</a>

        <button
          @click="toggleNav"
          class="nav-toggle-btn"
          aria-label="Toggle menu"
          ref="navtoggle"
        >
          <ion-icon
            name="menu-sharp"
            aria-hidden="true"
            class="menu-icon"
          ></ion-icon>
          <ion-icon
            name="close-sharp"
            aria-hidden="true"
            class="close-icon"
          ></ion-icon>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "DentalHeader",
  mounted() {
    window.addEventListener("scroll", this.headerScroll);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.headerScroll);
  },

  methods: {
    headerScroll() {
      const header = this.$refs.header;
      if (window.scrollY >= 100) {
        header.classList.add("active");
      } else {
        header.classList.remove("active");
      }
    },
    toggleNav() {
      this.$refs.navbar.classList.toggle("active");
      this.$refs.navtoggle.classList.toggle("active");
    },
    closeNav() {
      this.$refs.navbar.classList.remove("active");
      this.$refs.navtoggle.classList.remove("active");
    },
  },
};
</script>
